/**
 * AdminOrcaTaskRpcClient - AtomRpc integration for admin orca task endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaTaskRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaTaskRpcClient extends AtomRpc.Tag<AdminOrcaTaskRpcClient>()(
  "AdminOrcaTaskRpcClient",
  {
    group: AdminOrcaTaskRpcs,
    protocol: makeRpcClientLayer(AdminOrcaTaskRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
